/**
 * Texts and figures of "Season vs last year" (CU-869fmhmx8), the mock's exact copy. Alias-free.
 * The figures every dashboard writes the same way live in `Dashboards/@services/format.js` (CU-869fmjzrh S2).
 */
import { money, signedMoney, signedPct } from '../../../@services/format.js'

export { initials, money, ordinal, signedMoney, signedPct } from '../../../@services/format.js'

export const CMP_WORD = { ly: 'last year', lw: 'last week', yday: 'yesterday' }
export const CMP_SHORT = { ly: 'LY', lw: 'LW', yday: 'Yday' }
export const CMP_POSSESSIVE = { ly: "last year's", lw: "last week's", yday: "yesterday's" }
export const PREV_COLUMN = { ly: 'Last year', lw: 'A week before', yday: 'The day before' }
export const STAT_LABEL = { min: 'Min', avg: 'Avg', max: 'Max' }
export const STAT_WORD = { min: 'lowest price', avg: 'average price', max: 'highest price' }

export function cmpPhrase(cmp, same) {
	if (cmp === 'ly') return same ? 'vs the same date last year' : 'vs the same weekday last year'
	return cmp === 'lw' ? 'vs prices captured up to a week before' : 'vs prices captured up to the day before'
}

/** What a cell says about the change: `{ kind: 'none'|'eq'|'up'|'down', text, title? }` (CA 12, decision 1) */
export function deltaOf(cell, code) {
	if (!cell?.prev) {
		const title = cell?.why === 'passed' ? 'Pick-up before the comparison date: nothing new to compare' : 'No prices for this date in the comparison period'
		return { kind: 'none', text: 'no comparison', title }
	}
	const r = Math.round(cell.de)
	if (r === 0) return { kind: 'eq', text: '= no change' }
	const down = r < 0
	return { kind: down ? 'down' : 'up', arrow: down ? '▼' : '▲', pct: signedPct(cell.dp), amount: signedMoney(cell.de, code) }
}

export const thinTitle = (cell, cmp) => `Few prices behind this cell: ${cell.cur?.n ?? 0} now, ${cell.prev?.n ?? 0} ${CMP_WORD[cmp]}`
